"use strict";
/*
  Constants reused through-out the code.
  Please keep config-like constants within config/constants.ts.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpticalDiskDriveType = exports.DASH = void 0;
exports.DASH = '-';
exports.OpticalDiskDriveType = 'ODD';
//# sourceMappingURL=constants.js.map